import { render, staticRenderFns } from "./MailingsLettersBatch.vue?vue&type=template&id=21179e39&scoped=true&"
import script from "./MailingsLettersBatch.vue?vue&type=script&lang=ts&"
export * from "./MailingsLettersBatch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21179e39",
  null
  
)

export default component.exports